import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"add\"><title>资源 39</title><g data-name=\"图层 2\"><path d=\"M3.51 20.49a12 12 0 1 1 17 0 12 12 0 0 1-17 0zM8 2.5A10.31 10.31 0 1 0 21.5 8 10.32 10.32 0 0 0 8 2.5zm3.19 14.63v-4.27H6.84A.85.85 0 0 1 6 12a.83.83 0 0 1 .81-.81h4.33V6.87A.83.83 0 0 1 12 6a.84.84 0 0 1 .85.84v4.3h4.3a.85.85 0 0 1 0 1.69h-4.3v4.27a.85.85 0 1 1-1.69.06v-.06z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/add.svg
// module id = 4cSG
// module chunks = 6